var rtlMapping = {
  left: 'right',
  right: 'left'
};

function getBasePlacement(placement, rtl) {
  var basePlacement = (placement || '').split('-', 1).pop();
  return rtl && rtlMapping[basePlacement] || basePlacement;
}

export default getBasePlacement;
//# sourceMappingURL=getBasePlacement.js.map
